if (!customElements.get('custom-reviews')) {
  const TRANSITION_SPEED = 400;

  class CustomReviews extends HTMLElement {
    constructor() {
      super();
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.waitForSwiper();

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    disconnectedCallback() {
      this.cancelSwiperLoad?.();
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.destroySwiper();
    }

    waitForSwiper() {
      this.cancelSwiperLoad?.();
      this.cancelSwiperLoad = theme.prepareSwiper(this, () => this.initSwiper());
    }

    initSwiper() {
      if (this.swiper) return;

      this.viewport = this.querySelector('.custom-reviews__viewport');
      this.track = this.querySelector('.custom-reviews__track');
      this.slides = [...this.querySelectorAll('.custom-reviews__slide')];

      if (!this.viewport || !this.track || this.slides.length < 2) return;

      const nextButton = this.querySelector('button[name="next"]');
      const prevButton = this.querySelector('button[name="prev"]');
      const loop = this.dataset.loop === 'true';
      const autoplay = this.dataset.autoplay === 'true'
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.viewport.classList.add('swiper');
      this.track.classList.add('swiper-wrapper');
      this.slides.forEach((slide) => slide.classList.add('swiper-slide'));

      this.swiper = new window.Swiper(this.viewport, {
        a11y: {
          slideLabelMessage: '{{slideIndex}} / {{slidesLength}}'
        },
        autoHeight: true,
        autoplay: autoplay
          ? {
              delay: (Number(this.dataset.autoplaySpeed) || 6) * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        grabCursor: true,
        keyboard: { enabled: true },
        loop,
        navigation:
          nextButton && prevButton
            ? {
                nextEl: nextButton,
                prevEl: prevButton
              }
            : false,
        slidesPerView: 1,
        speed: TRANSITION_SPEED,
        watchOverflow: true
      });
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
      this.viewport?.classList.remove('swiper');
      this.track?.classList.remove('swiper-wrapper');
      this.slides?.forEach((slide) => slide.classList.remove('swiper-slide'));
    }

    /** Bring the review a merchant selected in the theme editor into view. */
    handleBlockSelect(evt) {
      if (!this.swiper) return;

      const slide = evt.target.closest?.('.custom-reviews__slide') || evt.target;
      // Loop mode reorders the slides in the DOM, so their position no longer
      // matches the block order. Swiper stamps the original index on each slide.
      const loopIndex = slide.dataset?.swiperSlideIndex;
      const index = loopIndex === undefined ? this.slides.indexOf(slide) : Number(loopIndex);

      if (index < 0) return;

      this.swiper.autoplay?.stop();

      if (this.swiper.params.loop) {
        this.swiper.slideToLoop(index);
      } else {
        this.swiper.slideTo(index);
      }
    }
  }

  customElements.define('custom-reviews', CustomReviews);
}
